import React from 'react';

import { PrimaryButton } from '../shared/Buttons';

type Props = {
  title: string;
  bgDark?: boolean;
  onClick: () => void;
};

export const CtaButton: React.FC<Props> = props => {
  const { title, bgDark, onClick } = props;

  return (
    <PrimaryButton className={bgDark ? 'bg-dark' : ''} onClick={onClick} data-testid='mp-product-cta-button' title={title}>
      {title}
    </PrimaryButton>
  );
};
